import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { PaginationType } from "@/types/common";
import { LangConstant } from "@/const";
import { AppScreenTitle, AppTable } from "@/components/common";
import useDeviceList from "./hooks/useDeviceList";
import useDeviceColumn from "./hooks/useDeviceColumn";

const DeviceListPage = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_DEVICE);

  const [pageData, setPageData] = useState<Partial<PaginationType>>({});
  const { deviceList, pagination } = useDeviceList(pageData);
  const { columnList } = useDeviceColumn();

  return (
    <Box>
      <AppScreenTitle>{getLabel("L_DEVICE_TITLE")}</AppScreenTitle>
      <AppTable
        data={deviceList}
        columns={columnList}
        pagination={pagination}
        onChangePagination={setPageData}
        hasCheckbox={false}
        onSelectedRequest={() => {}}
      />
    </Box>
  );
};

export default DeviceListPage;
